/*
    Imports the Roast API URL from the config.
*/

import apiCtrl from '@/services/api/abstract/abstract-api';
export default {
  getProfiles: function(profile, config = { params: {} }) {
    if (profile === 'consultant') {
      return apiCtrl.get('/admin/' + profile + '/filtered/all', config);
    } else {
      return apiCtrl.get('/admin/' + profile + '/all');
    }
  },

  getActiveProfiles: function(profile) {
    return apiCtrl.get('/admin/' + profile + '/all', { params: { active: true } });
  },

  getSelectActiveCustomerProfiles: function() {
    return apiCtrl.get('/admin/customer/input-select-all-active');
  },

  getCompaniesOfUsers: function(userIds) {
    return apiCtrl.get('/admin/customer/companies', { params: { userIds: userIds } });
  },

  myConsultants: function() {
    return apiCtrl.get('/my-consultants');
  },

  getMiniList: function(profile, config = {}) {
    return apiCtrl.get('/admin/' + profile + '/minilist', config);
  },

  linkAplifisaToUser: function(data) {
    return apiCtrl.post('/admin/aplifisa/link-user-to-aplifisa', data);
  },

  getProfile: function(profile, profileID) {
    return apiCtrl.get('/admin/' + profile + '/' + profileID);
  },

  postProfile: function(profile, data) {
    return apiCtrl.post('/admin/' + profile, data);
  },
  updateProfile: function(profile, data, id) {
    data['_method'] = 'put';
    return apiCtrl.post('/admin/' + profile + '/' + id, data);
  },

  deleteProfile: function(profile, id) {
    return apiCtrl.delete('/admin/' + profile + '/' + id);
  },

  restoreProfile: function(profile, id) {
    const data = { _method: 'put' };
    return apiCtrl.post('/admin/' + profile + '/restore/' + id, data);
  },

  assignCustomers: function(data, consultantID) {
    return apiCtrl.post('/admin/consultant/' + consultantID + '/assign-customers', data);
  },

  assignConsultants: function(data, customerID) {
    return apiCtrl.post('/admin/consultant/' + customerID + '/assign-consultants', data);
  },

  removeCustomers: function(data, consultantID) {
    return apiCtrl.post('/admin/consultant/' + consultantID + '/remove-customers', data);
  },

  removeConsultants: function(data, customerID) {
    return apiCtrl.post('/admin/consultant/' + customerID + '/remove-consultants', data);
  },

  removeAllCustomers: function(data, consultantID) {
    return apiCtrl.delete('/admin/consultant/' + consultantID + '/customers', data);
  },

  removeAllConsultants: function(data, customerID) {
    return apiCtrl.delete('/admin/consultant/' + customerID + '/consultants', data);
  },
};
